<template>
    <!-- 执行标准 -->
    <div class="container_page">
        <!-- <div class="lang-radio-wrap">
            <a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
                <a-radio-button value="CH">中文版</a-radio-button>
                <a-radio-button value="EN">英文版</a-radio-button>
            </a-radio-group>
        </div> -->
        <a-form layout="inline">
            <a-form-item label="举报单号">
                <a-input v-model="filterData.reportNo" placeholder="请输入举报单号"/>
            </a-form-item>
            <a-form-item label="举报人">
                <a-input v-model="filterData.reporterUserName" placeholder="请输入举报人"/>
            </a-form-item>
            <a-form-item label="处理结果">
                <a-select style="width: 200px" v-model="filterData.handleResult" class="mr12" placeholder="请选择处理状态"
                          show-search option-filter-prop="name" :filter-option="filterOption">
                    <a-select-option v-for="(item, index) of tagsTop" :key="index" :value="item.tagId">
                        {{ item.tagName }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="时间范围">
                <a-range-picker v-model="filterData.timeDate" class="mr12"/>
            </a-form-item>
            <a-form-item>
                <a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
                <a-button class="mr12" @click="toSearch(false)">重置</a-button>

                <!-- <a-button class="mr12" @click="scriptEdit">话术编辑</a-button>
                <a-button class="mr12">导入</a-button>
                <a-button @click="toAdd">新建标准</a-button> -->
            </a-form-item>
        </a-form>

        <div style="margin-top: 16px;margin-bottom: 16px;">
            <a-radio-group v-model="filterData.reportStatus" button-style="solid" @change="changeTab">
                <a-radio-button style="width: 150px;text-align: center;" value="ALL">
                    全部
                    <span>{{ allNum }}</span>
                </a-radio-button>
                <a-radio-button style="width: 150px;text-align: center;" value="PENDING">
                    待处理
                    <span>{{ pendingNum }}</span>
                </a-radio-button>
                <a-radio-button style="width: 150px;text-align: center;" value="PROCESSING">
                    处理中
                    <span>{{ processingNum }}</span>
                </a-radio-button>
                <a-radio-button style="width: 150px;text-align: center;" value="RESOLVED">
                    已处理
                    <span>{{ resolvedNum }}</span>
                </a-radio-button>
                <a-radio-button style="width: 150px;text-align: center;" value="CLOSED">
                    已关闭
                    <span>{{ closedNum }}</span>
                </a-radio-button>
            </a-radio-group>
        </div>
        <a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
                 :loading="loading">
            <template slot="handleActionRender" slot-scope="text, record">
                <span style="color:#2CBD9C"  v-if="record.handleAction == true">
                    是
                </span>
                <span v-else-if="record.handleAction == false">
                    否
                </span>
                <span v-else></span>
            </template>
            <template slot="handleResultRender" slot-scope="text, record">
                <span  style="color:#2db7f5" v-if="record.handleResult == 'VALID'">
                    有效举报
                </span>
                <span v-else-if="record.handleResult == 'MALICIOUS'"  style="color:#ff0000">
                    恶意举报
                </span>
                <span v-else-if="record.handleResult == 'INVALID'">
                    无效举报
                </span>
                <span v-else></span>
            </template>
            <template slot="reportStatusRender" slot-scope="text, record">
                <span  style="color:#f50" v-if="record.reportStatus == 'PENDING'">
                    待处理
                </span>
                <span style="color:#2db7f5"  v-else-if="record.reportStatus == 'PROCESSING'">
                    处理中
                </span>
                <span   style="color:#87d068"  v-else-if="record.reportStatus == 'RESOLVED'">
                    已解决
                </span>
                <span v-else-if="record.reportStatus == 'CLOSED'">
                    已关闭
                </span>
                <a-tag v-else></a-tag>
            </template>
            <template slot="isMsgToReporterRender" slot-scope="text, record">
                <span v-if="record.isMsgToReporter == 'SENT'" style="color:#2CBD9C">
                    是
                </span>
                <span v-else>否</span>
            </template>

            <template slot="reportContentRender" slot-scope="text, record">
                <div style="display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;" :title="record.reportContent">{{ record.reportContent }}</div>
            </template>

            <template slot="isMsgToTargetRender" slot-scope="text, record">
                <span v-if="record.isMsgToTarget == 'SENT'"  style="color:#2CBD9C">
                    是
                </span>
				<span v-else>否</span>
            </template>

            <template slot="action" slot-scope="text, record">
                <div class="flex_center">
                    <a-button type="link" @click="toEdit(record)">查看</a-button>
                </div>
            </template>

        </a-table>


    </div>
</template>

<script>
    import {
        getReportsApi,
    } from "../../api/index";

    export default {
        name: "cardsList",
        data() {
            return {
                editorOption: {
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['color', 'background'], // 颜色功能在这里
                            ['clean']

                        ],
                    },
                    placeholder: "请输入内容",
                    theme: 'snow'
                },
                columns: [{
                    title: '序号',
                    dataIndex: 'index',
                    key: 'index',
                    customRender: (text, record, index) => {
                        return (this.pageInfo.current - 1) * this.pageInfo.pageSize + index + 1
                    },
					width:40
                },
                    {
                        title: '举报单号',
                        dataIndex: 'reportNo',
                        key: 'reportNo',
						width:100

					},
                    {
                        title: '举报人',
                        dataIndex: 'reporterUserName',
                        key: 'reporterUserName',
                    },
                    {
                        title: '举报原因',
                        dataIndex: 'reportReason',
                        key: 'reportReason',
                    },
                    {
                        title: '举报描述',
                        dataIndex: 'reportDesc',
                        key: 'reportDesc',
                        width:200

                    },
                    {
                        title: '举报内容',
                        dataIndex: 'reportContent',
                        key: 'reportContent',
                        scopedSlots: {
                            customRender: 'reportContentRender'
                        },
                        width:200

                    },
                    {
                        title: '是否屏蔽举报内容',
                        dataIndex: 'handleAction',
                        key: 'handleAction',
                        scopedSlots: {
                            customRender: 'handleActionRender'
                        },
						width:90
                    },
                    {
                        title: '举报状态',
                        dataIndex: 'reportStatus',
                        key: 'reportStatus',
                        scopedSlots: {
                            customRender: 'reportStatusRender'
                        },
                    }, {
                        title: '处理结果',
                        dataIndex: 'handleResult',
                        key: 'handleResult',
                        scopedSlots: {
                            customRender: 'handleResultRender'
                        },
                    },
                    {
                        title: '举报人是否已发送系统消息',
                        dataIndex: 'isMsgToReporter',
                        key: 'isMsgToReporter',
                        scopedSlots: {
                            customRender: 'isMsgToReporterRender'
                        },
                        width: 120
                    }, {
                        title: '被举报人是否已发送系统消息',
                        dataIndex: 'isMsgToTarget',
                        key: 'isMsgToTarget',
                        scopedSlots: {
                            customRender: 'isMsgToTargetRender'
                        },
                        width: 120
                    },
                    {
                        title: '举报时间',
                        dataIndex: 'createTime',
                        key: 'createTime',
                    },
                    {
                        title: '操作',
                        key: 'action',
                        scopedSlots: {
                            customRender: 'action'
                        },
                    }
                ],
                tableData: [],
                pageInfo: {
                    pageSize: 20,
                    current: 1,
                    total: 0,
                    showTotal: (total, range) => {
                        return `合计 ${total} 条记录`;
                    },
                },
                loading: false,
                imgModel: {
                    flag: false,
                    url: "",
                },
                labelCol: {
                    span: 4
                },
                wrapperCol: {
                    span: 18
                },
                filterData: {
                    reportNo: "",
                    reporterUserName: "",
                    handleResult: undefined,
                    reportStatus: 'ALL',
                    timeDate: [],
                },
                tagsTop: [{
                    tagId: 'VALID',
                    tagName: "有效举报"
                },
                    {
                        tagId: 'MALICIOUS',
                        tagName: "恶意举报"
                    },
                    {
                        tagId: 'INVALID',
                        tagName: "无效举报"
                    }
                ],
                // 标签统计数量
                allNum: 0,
                pendingNum: 0,
                processingNum: 0,
                resolvedNum: 0,
                closedNum: 0,
                tags: [{
                    tagId: 'ALL',
                    tagName: "全部",
                    numKey: 'allNum'
                },
                    {
                        tagId: 'PENDING',
                        tagName: "待处理",
                        numKey: 'pendingNum'
                    },
                    {
                        tagId: 'PROCESSING',
                        tagName: "处理中",
                        numKey: 'processingNum'
                    },
                    {
                        tagId: 'RESOLVED',
                        tagName: "已处理",
                        numKey: 'resolvedNum'
                    },
                    {
                        tagId: 'CLOSED',
                        tagName: "已关闭"
                    }
                ],
            };
        },
        created() {
        },
        activated() {
        },
        mounted() {
            const storedQuery = localStorage.getItem('oemConsult_searchQuery');
            console.log(storedQuery)
            if (storedQuery) {
                this.filterData = JSON.parse(storedQuery);
                if (!this.filterData.reportStatus) {
                    this.filterData.reportStatus = 'ALL';
                }
            } else {
                this.filterData.reportStatus = 'ALL';
            }
            this.getData(1)
        },
        beforeRouteLeave(to, from, next) {
            localStorage.setItem('oemConsult_searchQuery', JSON.stringify(this.filterData));
            next();
        },
        methods: {
            changeTabTop() {
                this.pageInfo.current = 1;
                this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
            },
            changeTab() {
                this.pageInfo.current = 1;
                this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },

            changePage(page) {
                this.pageInfo.current = page.current;
                this.getData(this.pageInfo.current);
            },
            toSearch(flag) {
                if (flag) {
                    this.getData(1);
                } else {
                    let reportStatus = this.filterData.reportStatus
                    this.filterData = {
                        reportNo: "",
                        reporterUserName: "",
                        handleResult: undefined,
                        reportStatus: reportStatus,
                        timeDate: [],
                    };
                    this.getData(1);
                }
            },
            getData(page = 1) {
                this.pageInfo.current = page;
                if (this.loading) {
                    return;
                }
                this.loading = true;
                getReportsApi({
                    startDate: this.filterData.timeDate.length === 2 ?
                        this.$moment(this.filterData.timeDate[0]).format(
                            "YYYY-MM-DD 00:00:00"
                        ) :
                        null,
                    endDate: this.filterData.timeDate.length === 2 ?
                        this.$moment(this.filterData.timeDate[1]).format(
                            "YYYY-MM-DD 23:59:59"
                        ) :
                        null,
                    reportNo: this.filterData.reportNo,
                    reporterUserName: this.filterData.reporterUserName,
                    handleResult: this.filterData.handleResult,
                    reportStatus: this.filterData.reportStatus === "ALL" ? null : this.filterData.reportStatus,
                    pageNo: this.pageInfo.current,
                    pageSize: this.pageInfo.pageSize,

                })
                    .then((res) => {
                        if (res.resultStatus) {
                            this.tableData = res.resultData.dataList || [];
                            this.pageInfo.total = res.resultData.totalNum || 0;

                            //   // 后端返回的统计字段赋值
                            this.allNum = res.resultData.allNum || 0;
                            this.pendingNum = res.resultData.pendingNum || 0;
                            this.processingNum = res.resultData.processingNum || 0;
                            this.resolvedNum = res.resultData.resolvedNum || 0;
                            this.closedNum = res.resultData.closedNum || 0;

                        } else {
                            this.tableData = [];
                            this.pageInfo.total = 0;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            toAdd() {
            },
            toEdit(data) {
                this.$router.push({
                    name: 'COMPLAINTDETAILMANAGE',
                    params: {
                        id: data.reportId
                    }
                });
            }
        },
    };
</script>

<style lang="less">
    .container_page {
        padding: 20px;
        background: #ffffff;

        .filter_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 12px;
        }

        .mr12 {
            margin-right: 12px;
        }
    }

    .size_item {
        height: 50px;
        /* 改为固定高度，不要 min-height */
        background: #f7f7f7;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 8px 0;
        /* 间距改小，更美观 */
        cursor: move;
        padding: 0 10px;

        .left {
            flex: 1;
            padding-left: 10px;
        }

        .right {
            width: 50px;
            text-align: center;
        }
    }

    .lang-radio-wrap {
        display: flex;
        justify-content: center;
        margin-bottom: 16px;
    }
</style>
